import axios from 'axios';
import { getSession } from 'next-auth/react';

export const baseURL = '/api';
const nextApi = axios.create({
  baseURL,
  withCredentials: true,
});

// register request interceptors
nextApi.interceptors.request.use(
  async (config) => {
    const get = await getSession();

    const token = get?.user?.accessToken;
    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  async (error: Error) => {
    return await Promise.reject(error);
  },
);

// register response interceptors
nextApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: Error) => {
    return Promise.reject(error);
  },
);

export default nextApi;
